import styled, { css } from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { ReactComponent as BadgeError } from 'src/components/Icons/Basic/icons_badge_error.svg'
import { ReactComponent as BadgeSuccess } from 'src/components/Icons/Basic/icons_badge_success.svg'
import { ReactComponent as NavigateIcon } from 'src/components/Icons/Basic/icons_navigate.svg'
import { ReactComponent as ClockIcon } from 'src/components/Icons/Basic/icons_clock.svg'
import { ReactComponent as ReceptorIcon } from 'src/components/Icons/Basic/icons_receptor.svg'
import { ReactComponent as ReportScanIcon } from 'src/components/Icons/Basic/icons_report_scan.svg'
import { ReactComponent as PlaybookIcon } from 'src/components/Icons/Basic/icons_playbook.svg'
import { ReactComponent as ArrowForwardIcon } from 'src/components/Icons/assets/arrow-forward-icon.svg'
import { ReactComponent as TimeZoneIcon } from 'src/components/Icons/Basic/icons_timezone.svg'
import { GridColumn } from 'src/components/Reusable/Grid'
import { Spinner } from 'src/Throbber'
import { P } from 'src/components/Reusable/Text/Text.styles'

export const SpinnerStyled = styled(Spinner)`
  color: #2196f3;
  border-color: #2196f3;
  border-right-color: transparent;
`

export const BadgeErrorIcon = styled(BadgeError)`
  height: 16px;
  width: 16px;
`

export const BadgeSuccessIcon = styled(BadgeSuccess)`
  height: 16px;
  width: 16px;
`

export const NavigateIconStyled = styled(NavigateIcon)`
  height: 16px;
  width: 16px;
  cursor: pointer;
`

export const ClockIconStyled = styled(ClockIcon)`
  height: 16px;
  width: 16px;
`

export const ReceptorIconStyled = styled(ReceptorIcon)`
  height: 16px;
  width: 16px;
`

export const ReportScanIconStyled = styled(ReportScanIcon)`
  height: 16px;
  width: 16px;
  path {
    fill: ${palette.neutral[900]};
  }
`

export const PlaybookIconStyled = styled(PlaybookIcon)`
  height: 16px;
  width: 16px;
`
export const ArrowForwardIconStyled = styled(ArrowForwardIcon)`
  height: 16px;
  width: 16px;
  transform: rotate(180deg);
  cursor: pointer;
  g {
    fill: ${palette.neutral[900]};
  }
`

export const TimeZoneIconStyled = styled(TimeZoneIcon)`
  height: 16px;
  width: 16px;
`

export const GridHeaderDivider = styled.div`
  display: grid;
  grid-column: 1 / -1;
  height: 1px;
  width: 100%;
  background-color: ${palette.neutral[50]};
`

export const MenuItemText = styled(P)`
  color: ${palette.neutral[900]};
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
`

const clickableStyles = css<{ $isClickable?: boolean }>`
  ${(props) =>
    props.$isClickable &&
    `
    cursor: pointer;
    text-decoration: underline;
  `}
`

export const ScheduleText = styled(P)`
  color: ${palette.neutral[900]};
  font-weight: 400;
  font-size: 14px;
`
export const ScheduleTextLight = styled(P)<{ $isClickable?: boolean }>`
  color: ${palette.neutral[500]};
  font-weight: 400;
  font-size: 14px;
  ${clickableStyles}
`
export const ScheduleCard = styled.div`
  display: flex;
  border-radius: 10px;
  padding: 13px 15px;
  min-height: 64px;
  min-width: 100px;
  width: 100%;
  height: auto;
  border: 1px solid ${palette.neutral[100]};
  flex-grow: 1;
  cursor: pointer;
`

export const Divider = styled.div`
  display: flex;
  position: relative;
  margin-top: 16px;
  height: 1px;
  width: 100%;
  background-color: ${palette.neutral[100]};
`

export const DividerText = styled.div`
  position: absolute;
  left: 50%;
  color: ${palette.neutral[400]};
  font-weight: 400;
  font-size: 14px;
  top: -10px;
  padding: 0 16px;
  background: white;
`
export const SchedulingDropdownContainer = styled.div`
  display: flex;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  align-items: center;
`
export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: auto;
  max-height: 150px;
  width: 100%;
  overflow-y: auto;
`

export const GridColumnStyled = styled(GridColumn)<{
  isDisabled?: boolean
}>`
  ${(props) => {
    if (props.isDisabled) {
      return `color: ${palette.neutral[400]};`
    }
  }}
`

export const StyledAddEventModalTitle = styled.h5`
  margin-bottom: 0;
`
export const ViewOnlyField = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  border: 1px solid ${palette.neutral[100]};
  border-radius: 8px;
  padding: 8px 8px 8px 12px;
  width: fit-content;
  color: ${palette.neutral[400]};
  white-space: nowrap;
`

export const CardGridContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`

export const ScheduleShowLabel = styled.p<{ isDisabled?: boolean }>`
  color: ${(props) =>
    props.isDisabled ? palette.neutral[400] : palette.neutral[900]};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`

export const ScheduleShowValue = styled.div<{
  isDisabled?: boolean
  $isClickable?: boolean
}>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${(props) =>
    props.isDisabled ? palette.neutral[400] : palette.neutral[900]};
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  ${clickableStyles}
`
export const ShowPageActionButton = styled.div`
  display: inline-flex;
  gap: 8px;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  color: ${palette.blue[600]};
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 8px;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${palette.neutral[50]};
  }
`

export const ShowPageActionDivider = styled.div`
  width: 1px;
  height: 1em;
  background-color: ${palette.blue[600]};
  align-self: center;
`

export const InlineSaveButton = styled.button`
  background-color: ${palette.blue[600]};
  color: ${palette.neutral.white};
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  &:hover:not(:disabled) {
    background-color: ${palette.blue[700]};
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const InlineCancelButton = styled.button`
  background-color: transparent;
  color: ${palette.neutral[600]};
  border: 1px solid ${palette.neutral[300]};
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover:not(:disabled) {
    background-color: ${palette.neutral[50]};
    border-color: ${palette.neutral[400]};
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
